import { GraphicActionType, GraphicPageMode, MapsState } from '../../model/GraphicModel';
import { GraphicAction } from './actions';
import { GraphicActionTypes } from './actionTypes';

const INIT_STATE: MapsState = {
	viewMode: GraphicPageMode.Live,
	graphicActionType: GraphicActionType.Directory,
	graphicInfo: {
		Id: -1,
		Name: '',
	},
	spaceObject: {
		VelocityObjects: [],
		PointMonitoringZones: [],
		CommandSets: [],
		Links: [],
		Texts: [],
	},
	error: '',
	showAlarmNoteModal: false,
	showAlarmTableModal: false,
	hasChanged: false,
	alarmPermissions: undefined,
	errorMessages: [],
	dropDataNodes: [],
	drawingMenuOptsDisabled: false,
	currentRedlineConfigValues: {
		color: '#FF0000',
		fillColor: '#FFFFFF',
		width: 4,
	},
	floatingWindowsVisibility: {
		birdEye: true,
		alarmQueue: true,
		devices: true,
		objectProperties: true,
		plottedDevices: true,
		quickAccess: true,
		alreadyLoaded: false,
	},
	lastObjectDirectoryCoordinates: {
		x: 0,
		y: 0,
	},
	lastPlottedDevicesCoordinates: {
		x: 0,
		y: 0,
	},
	lastAlarmQueueCoordinates: {
		x: 0,
		y: 0,
	},
};

//Reducers
const mapReducer = (state: Readonly<MapsState> = INIT_STATE, action: GraphicAction): MapsState => {
	switch (action.type) {
		case GraphicActionTypes.SET_SPACE_OBJECT_DATA:
			const {
				payload: { FileName: MapFileName, VelocityObjects, PointMonitoringZones, CommandSets, Links, Texts },
			} = action;
			return {
				...state,
				spaceObject: {
					FileName: MapFileName,
					VelocityObjects: VelocityObjects,
					PointMonitoringZones: PointMonitoringZones,
					CommandSets: CommandSets,
					Links: Links,
					Texts: Texts,
				},
			};
		case GraphicActionTypes.SET_MAP_DIRECTORY_DATA:
			return {
				...state,
				graphicInfo: {
					...state.graphicInfo,
					...action.payload,
				},
			};
		case GraphicActionTypes.SET_ERROR_MESSAGE:
			return {
				...state,
				error: action.payload,
			};
		case GraphicActionTypes.SET_ERROR_MESSAGES:
			return {
				...state,
				errorMessages: action.payload,
			};
		case GraphicActionTypes.SET_DROP_DATA_NODES:
			return {
				...state,
				dropDataNodes: action.payload,
			};
		case GraphicActionTypes.MAP_HAS_CHANGED:
			return {
				...state,
				hasChanged: action.payload,
			};
		case GraphicActionTypes.SET_ALARM_PERMISSIONS:
			return {
				...state,
				alarmPermissions: action.payload,
			};
		case GraphicActionTypes.DISABLE_MENU_OPTS:
			return {
				...state,
				drawingMenuOptsDisabled: action.payload,
			};
		case GraphicActionTypes.SET_CURRENT_REDLINE_CONFIG_VALUES:
			return {
				...state,
				currentRedlineConfigValues: action.payload,
			};
		case GraphicActionTypes.SAVE_GRAPHIC_PREFERENCES:
			return {
				...state,
				error: '',
			};
		case GraphicActionTypes.SAVE_GRAPHIC_PREFERENCES_SUCCESS:
			return {
				...state,
				error: '',
			};
		case GraphicActionTypes.SET_MAP_MODE:
			return {
				...state,
				viewMode: action.payload,
			};
		case GraphicActionTypes.SET_GRAPHIC_ACTION_TYPE:
			return {
				...state,
				graphicActionType: action.payload,
			};
		case GraphicActionTypes.SWITCH_FLOATING_WINDOW_VISIBILITY:
			return {
				...state,
				floatingWindowsVisibility: {
					...state.floatingWindowsVisibility,
					...action.payload,
				},
			};
		case GraphicActionTypes.SET_LAST_OBJECT_LIBRARY_COORDINATES:
			return {
				...state,
				lastObjectDirectoryCoordinates: action.payload,
			};
		case GraphicActionTypes.SET_LAST_PLOTTED_DEVICES_COORDINATES:
			return {
				...state,
				lastPlottedDevicesCoordinates: action.payload,
			};
		case GraphicActionTypes.SET_LAST_ALARM_QUEUE_COORDINATES:
			return {
				...state,
				lastAlarmQueueCoordinates: action.payload,
			};
		default:
			return { ...state };
	}
};

export { mapReducer };
